const RPrxiesPrice = [
  {
    id: 1,
    name: '1',
    price: 10,
  },
  {
    id: 2,
    name: '2',
    price: 18,
  },
  {
    id: 3,
    name: '5',
    price: 35,
  },
  {
    id: 4,
    name: '10',
    price: 65,
  },
  {
    id: 5,
    name: '20',
    price: 120,
  },
  {
    id: 6,
    name: '40',
    price: 210,
  },
  {
    id: 7,
    name: '75',
    price: 345,
  },
  {
    id: 8,
    name: '100',
    price: 400,
  },
];

export default RPrxiesPrice;
